import React, { useEffect, useState } from 'react';
import { PortalShell } from '@/components/nav/PortalShell';
import { portalApi } from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { fmtMoney, fmtDate, fmtDocNumber } from '@/lib/format';
import { Link } from 'react-router-dom';
import { EmptyState } from '@/components/empty/EmptyState';
import { ListSkeleton } from '@/components/common/ListSkeleton';
import { Receipt } from 'lucide-react';

export default function PortalInvoicesPage() {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    portalApi.invoices()
      .then(setItems)
      .catch(() => {}) // surfaced by the api response interceptor
      .finally(() => setLoaded(true));
  }, []);
  return (
    <PortalShell title="Invoices">
      <h1 className="font-display text-2xl md:text-3xl font-semibold mb-4">Invoices</h1>
      {!loaded ? (
        <ListSkeleton />
      ) : items.length === 0 ? (
        <EmptyState icon={Receipt} title="No invoices yet" description="When we bill you, invoices will appear here." />
      ) : (
        <Card><CardContent className="p-0"><div className="divide-y">
          {items.map(i => (
            <Link key={i.id} to={`/portal/invoices/${i.id}`} className="flex items-center justify-between px-4 py-3 hover:bg-muted/40">
              <div>
                <div className="font-medium text-sm">{fmtDocNumber(i, 'Invoice')}</div>
                <div className="text-xs text-muted-foreground">{fmtDate(i.created_at)}</div>
              </div>
              <div className="flex items-center gap-2">
                <Badge variant={i.status === 'paid' ? 'default' : 'outline'}>{i.status}</Badge>
                <div className="font-semibold tabular-nums w-24 text-right">{fmtMoney(i.total)}</div>
              </div>
            </Link>
          ))}
        </div></CardContent></Card>
      )}
    </PortalShell>
  );
}
